import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { HEADER_HEIGHT_MOBILE } from 'components/Layouts/mobileStyles';
import { SearchProgressBar } from 'components/SearchProgressBar';
import { motion, useViewportScroll } from 'framer-motion';
import { getIsTopHeaderHidden } from 'modules/search/selectors';
import { setIsTopHeaderHidden } from 'modules/search/slice';
import { getIsSearchBoxOpen } from 'modules/searchBox/selectors';
import OpacityAnimation from '@daedalus/atlas/helpers/OpacityAnimation';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { MobileHeaderContent, Props as MobileHeaderProps } from './MobileHeaderContent';
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hp78s1c",
  propsAsIs: false
});
export const MobileHeader = ({
  className,
  hasShadow,
  hasDivider,
  hasHeaderSearchSummary,
  hasHeaderBottomContent,
  hasHeaderMenu,
  hasSearchProgressBar,
  rightContent,
  hasBackButton,
  headerTitle
}: MobileHeaderProps) => {
  const dispatch = useDispatch();
  const {
    brandHasCollapsingHeader
  } = useBrand();
  const topHeaderIsHidden = useSelector(getIsTopHeaderHidden);
  const isSearchBoxOpen = useSelector(getIsSearchBoxOpen);
  const {
    scrollY
  } = useViewportScroll();
  useEffect(() => {
    if (brandHasCollapsingHeader) {
      scrollY.onChange(v => {
        dispatch(setIsTopHeaderHidden(Boolean(v > HEADER_HEIGHT_MOBILE)));
      });
    }
  }, [scrollY, dispatch, brandHasCollapsingHeader]);
  useEffect(() => {
    if (brandHasCollapsingHeader) {
      dispatch(setIsTopHeaderHidden(false));
    }
  }, [dispatch, location.pathname, brandHasCollapsingHeader]);
  return <HeaderWrapper className={className}>
      <OpacityAnimation delay={500}>
        <motion.div style={{
        position: brandHasCollapsingHeader ? 'fixed' : 'relative',
        width: '100%'
      }} initial={false} animate={{
        top: topHeaderIsHidden ? -HEADER_HEIGHT_MOBILE : 0
      }}>
          <MobileHeaderContent hasShadow={hasShadow} hasDivider={hasDivider} hasHeaderSearchSummary={hasHeaderSearchSummary} hasHeaderBottomContent={hasHeaderBottomContent} hasHeaderMenu={hasHeaderMenu} rightContent={rightContent} hasBackButton={hasBackButton} headerTitle={headerTitle} />
          {hasSearchProgressBar && !isSearchBoxOpen && <SearchProgressBar />}
        </motion.div>
      </OpacityAnimation>
    </HeaderWrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");